// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sample-list[data-v-85f410ca]{background:#f5f5f5;padding-top:31px;padding-bottom:4px}.sample-list[data-v-85f410ca]  .sample-item{margin-bottom:0;padding-bottom:0;padding-top:0}.sample-list[data-v-85f410ca]  .ind-sample-title{left:38px;top:13px}", ""]);
// Exports
module.exports = exports;
